import React from "react";
import { Wrapper, Container } from "./styles";

const Radio = ({
  isSelected,
  size
}: {
  isSelected: boolean;
  size?: number;
}) => {
  return (
    <Wrapper>
      <Container size={size} isSelected={isSelected} />
    </Wrapper>
  );
};

export default Radio;
